export default __webpack_public_path__ + "img/footer-834b4b91.png";